export default __webpack_public_path__ + "static/media/music-key-green.25cd20ac.svg";